module.exports = __webpack_public_path__ + "media/images/flags/16/Eritrea-6b7078ae1dbd78eb096df8dec946a7e2.png";